export const  overdueCode = ["400001"]